import { createContext, useContext, useRef, useState } from "react";
import * as StateLib from "../Utils/StateLib";
import { kDefaultDirFields } from "@coreapp/constants";
import { filterInternalFields } from "@/Utils/FilterInternalFields";

const DirectorySearchContext = createContext();

const DirectorySearchProvider = ({ children }) => {
  let defaultSearchState = {
    columnNames: [],
    loading: false,
    results: []
  };
  const [dirSearchState, setDirSearchState] = useState(defaultSearchState);

  const tableHandleRef = useRef(null);
  const searchCtrl = useRef(null);

  const ResetColumnNames = (selectedChartID = null) => {
    let doc = StateLib.GetDoc();
    let wsMgr = StateLib.GetWSMgr();
    if (!doc) return;
    let columnNames;
    let chartID = selectedChartID ? selectedChartID : doc.GetChartID();
    let org = wsMgr.GetAccountName();
    let dirInfo = doc.fDirectoryInfo;

    const allowedColumnNames = doc.GetDirectoryColumns();
    const filteredAllowedColumnNames = filterInternalFields(allowedColumnNames);

    // Read `localStorage` for user-configured columns
    // Only consider columns from cache that match allowed columns
    if (localStorage.directoryColumnFields) {
      let columnData = JSON.parse(localStorage.directoryColumnFields);
      if (columnData[org + "_" + chartID]) {
        const userConfiguredColumns = columnData[org + "_" + chartID];
        columnNames = userConfiguredColumns.filter(fieldName =>
          filteredAllowedColumnNames.includes(fieldName)
        );
      }
    }

    // If no columns are stored in localStorage, fallback to defaults
    if (!columnNames || columnNames.length === 0) {
      columnNames = [];

      const objDB = doc.GetObjDB();
      const boxClass = objDB.GetClassByName("Box");

      const defaultColumnNames = [];
      for (let i of kDefaultDirFields) {
        let fieldDef = boxClass.GetFieldDefByID(i);
        if (!fieldDef) {
          fieldDef = boxClass.GetFieldDefByName(i);
        }

        if (!fieldDef) {
          continue;
        }

        const fieldName = fieldDef.GetFieldName();
        defaultColumnNames.push(fieldName);
      }

      // Only consider allowed columns that are also in the default list.
      // Filter on allowed columns to maintain the order of allowed columns set in settings
      columnNames = filteredAllowedColumnNames.filter(fieldName =>
        defaultColumnNames.includes(fieldName)
      );
    }

    // If no columns are allowed, fallback to all allowed columns
    if (columnNames.length === 0) {
      columnNames = filteredAllowedColumnNames;
    }

    setDirSearchState(prevState => {
      return { ...prevState, columnNames };
    });
  };

  const UpdateSearchResults = newResults => {
    setDirSearchState(prevState => {
      return { ...prevState, results: newResults.slice(0) };
    });
  };

  return (
    <DirectorySearchContext.Provider
      value={{
        dirSearchState,
        setDirSearchState,
        ResetColumnNames,
        UpdateSearchResults,
        searchCtrl,
        tableHandleRef
      }}
    >
      {children}
    </DirectorySearchContext.Provider>
  );
};

export const useDirectorySearchContext = () => useContext(DirectorySearchContext);

export default DirectorySearchProvider;
